import { UnauthenticatedApp } from "UnauthenticatedApp";
import "core-js";
import "trix";
import "trix/dist/trix.css";
import "./i18n";
import React from "react";
import { createRoot } from "react-dom/client";

document.addEventListener("DOMContentLoaded", () => {
  const mainDom = document.getElementById("react-main");
  if (mainDom) {
    const root = createRoot(mainDom);
    root.render(<UnauthenticatedApp />);
  }
});
